export type FeatureFlag<Key extends string> = {
  key: Key;
  description: string;
  createdAt?: `${string}/${string}/${string}`;
};

export const featureFlags = [
  {
    key: 'additionalSchedulingOptions',
    description:
      'Allow the usage of additional monthly scheduling options for audiences on the export modal',
  },
  {
    key: 'allowAdvancedDelay',
    description: '',
  },
  {
    key: 'audienceScheduleOnExportModal',
    description:
      'Allow the usage of scheduling feature for audiences on the export modal',
  },
  {
    key: 'showEvaluationLimit',
    description:
      'Show the fields under the evaluation settings to limit the number of criteria records passing forwards per column',
  },
  {
    key: 'datasetCreatePage',
    description: `Enable the pages for dataset creation and editing,
      instead of using the related modals`,
  },
  {
    key: 'datasetGroupsCreatePage',
    description: `
    Turn on the new page for creating/editing a dataset group
    that should replace the current dataset group create/edit modals.
    `,
    createdAt: '2024/02/28',
  },
  {
    key: 'enhancedMatchRate',
    description: 'Show enhanced match rate option on export v2',
  },
  {
    key: 'hasDelayMinutes',
    description: 'Add minutes as an unit under delay node',
  },
  {
    key: 'isMlbOrg',
    description: '',
  },
  {
    key: 'journeyBuilder',
    description: 'Journey Builder enabled',
  },
  {
    key: 'joinCardinalitySelectionEnabled',
    description:
      'On datasets join configuration, allows the join cardinality selection, i.e., if the join is a one-one, one-to-many, many-to-one, many-to-many relation',
    createdAt: '2024/04/20',
  },
  {
    key: 'joinConfigurationOnModelsPageEnabled',
    description: `
      Allow the user to set a join configuration between a dataset and a computed field (Model with User Trait type) directly on the Models page.
      This FF also hides the join key, as it is not required.
      Created at 2024/08/09'
    `,
    createdAt: '2024/08/09',
  },
  {
    key: 'fullAudienceRefreshEnabled',
    description: `
      Allows for the full audience to be sent to a destination for all destinations. Not just the delta in audience'
    `,
    createdAt: '2024/08/09',
  },
  {
    key: 'leftDatasetSelectionEnabled',
    description:
      'On datasets join configuration, allows the selection of any left dataset, not necessarily the customer_details one',
    createdAt: '2024/04/20',
  },
  {
    key: 'marveEnabled',
    description: 'Enable marve options on dataset group pages',
  },
  {
    key: 'manyToManyCardinalityEnabled',
    description:
      'Includes the many to many option under the join cardinalities',
    createdAt: '2024/04/20',
  },
  {
    key: 'piiFeatureEnabled',
    description:
      'Enable the declaration of pii fields on the dataset configuration',
  },
  {
    key: 'showAdditionalFields',
    description: 'Show Personalization V2 Component',
  },
  {
    key: 'showAllFieldCheckBoxes',
    description:
      'Show all field checkboxes on additional fields form and personalization multiselect form',
  },
  {
    key: 'kohlsAllFieldsButton',
    description:
      'Show button to add primary table fields on additional fields form',
  },
  {
    key: 'showAdditionalFieldsJourneys',
    description: 'Show Personalization V2 Component For Journeys',
  },
  {
    key: 'showAudienceScheduleOnDestinationNode',
    description: 'Enable user to configure audience export schedule',
  },
  {
    key: 'showCriteriaEvaluation',
    description: 'Enable user to configure criteria evaluation window',
  },
  {
    key: 'showExperiments',
    description: 'Experiment Node activated',
  },
  {
    key: 'showCRM',
    description: 'CRM Node activated',
  },
  {
    key: 'showExportDuration',
    description: '',
  },
  {
    key: 'showGlobalExit',
    description: 'Enable global exit audiences on journey',
  },
  {
    key: 'showNestedMatchFields',
    description: 'Show Nested Match Fields Component',
  },
  {
    key: 'showReentry',
    description: 'Enable user reentry on journey',
  },
  {
    key: 'showReportingTooltip',
    description: 'tooltip for journeys metrics on report chips',
  },
  {
    key: 'audienceQueryLimitAndOrder',
    description: 'show thew query limit, rank and sort in audience settings',
  },
  {
    key: 'showSimulate',
    description: '',
  },
  {
    key: 'bulkExportJourneys',
    description:
      'show the action button to download journeys in bulk from the index page',
    createdAt: '2024/09/20',
  },
  {
    key: 'bulkArchiveJourneys',
    description:
      'show the action button to archive journeys in bulk from the index page',
    createdAt: '2024/09/20',
  },
  {
    key: 'bulkDeleteJourneys',
    description:
      'show the action button to delete journeys in bulk from the index page',
    createdAt: '2024/09/20',
  },
  {
    key: 'showStepActivityTable',
    description: 'show step activity table',
    createdAt: '2024/04/24',
  },
  {
    key: 'audienceExportWritePermission',
    description: '',
  },
  {
    key: 'audienceTemplateWritePermission',
    description: '',
  },
  {
    key: 'chooseYourExportObject',
    description: 'allow user to select secondary dataset on audience export',
  },
  {
    key: 'hardResetJourney',
    description: 'Enable hard reset option on journeys',
  },
  {
    key: 'allowFieldAliasing',
    description: 'Turn on the field aliasing feature',
  },
  {
    key: 'campaignTriggers',
    description: 'Can see Campaign Triggers fields',
    createdAt: '2024/12/10',
  },
  {
    key: 'canEditLockedTemplates',
    description: 'Can edit locked templates',
  },
  {
    key: 'pageViewTiming',
    description: 'Allows for NewRelic page view timing.',
  },
  {
    key: 'sessionTracing',
    description: 'Allows for NewRelic session tracing.',
  },

  {
    key: 'tablesRefreshButton',
    description: 'Display refresh button for tables based components',
    createdAt: '2024/10/08',
  },
  {
    key: 'datasetsRefreshButton',
    description: 'Display a refresh Button for datasets based components',
    createdAt: '2024/10/24',
  },
  {
    key: 'computedFieldsCustomAttributes',
    description: 'Add computed fields to custom attributes',
    createdAt: '2024/10/31',
  },
  {
    key: 'journeysManualMode',
    description:
      'Enable manual mode for journeys, allowing users to manually trigger journey steps',
    createdAt: '2024/10/01',
  },
  {
    key: 'datasetFilters',
    description: 'Enable filters for Datasets',
    createdAt: '2024/11/18',
  },
  {
    key: 'tableNameUniquenessCheck',
    description:
      'Enable validation to ensure table names are unique when configuring paid media exports',
    createdAt: '2024/12/11',
  },
  {
    key: 'criteriaGroups',
    description: 'Enables criteria groups.',
    createdAt: '2024/12/20',
  },
  {
    key: 'realtimeJourneys',
    description: 'Enables realtime journeys',
    createdAt: '2025/01/27',
  },
  {
    key: 'resetUserConsent',
    description: 'Do not preselect the user consent field when exporting',
    createdAt: '2025/01/14',
  },
  {
    key: 'realtimeEvents',
    description: 'Enables realtime event sources.',
    createdAt: '2025/01/14',
  },
  {
    key: 'ingestDestinations',
    description: 'Allow to ingest destinations (link to an import source)',
    createdAt: '2025/01/19',
  },
  {
    key: 'loopTracker',
    description: 'Enable loop tracker',
    createdAt: '2025/03/06',
  },
  {
    key: 'showAIStudio',
    description: 'Enable AI Studio',
    createdAt: '2025/04/07',
  },
  {
    key: 'showNewJourneyBuilder',
    description: 'Enable new journey builder',
    createdAt: '2025/04/28',
  },
  {
    key: 'marketoCustomObject',
    description: 'Enable selection of Marketo custom objects',
    createdAt: '2025/05/23',
  },
  {
    key: 'notifyOnNullUniqueKey',
    description: 'Enable notification on null resolution',
    createdAt: '2025/05/13',
  },
  {
    key: 'programsEnabled',
    description: 'Enable Programs feature (v2)',
    createdAt: '2025/07/28',
  },
  {
    key: 'audienceAdvancedBreakdowns',
    description: 'Enable advanced breakdowns for audiences',
    createdAt: '2025/08/06',
  },
] as const;

export type FeatureFlagKey = (typeof featureFlags)[number]['key'];

if (__DEV__) {
  const set = new Set<string>();
  for (const flag of featureFlags) {
    if (set.has(flag.key)) {
      console.warn(`Feature flag "${flag.key}" is duplicated`);
    }
    set.add(flag.key);
  }
}
